var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimePast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5004 8V11.5859L15.2074 13.293C15.5984 13.684 15.5984 14.316 15.2074 14.707C15.0124 14.902 14.7564 15 14.5004 15C14.2444 15 13.9883 14.902 13.7933 14.707L11.7933 12.707C11.6053 12.519 11.5004 12.265 11.5004 12V8C11.5004 7.448 11.9474 7 12.5004 7C13.0534 7 13.5004 7.448 13.5004 8ZM12.5263 2C9.85625 2 7.34937 3.07793 5.50037 4.92993V3C5.50037 2.448 5.05337 2 4.50037 2C3.94737 2 3.50037 2.448 3.50037 3V7C3.50037 7.552 3.94737 8 4.50037 8H8.50037C9.05337 8 9.50037 7.552 9.50037 7C9.50037 6.448 9.05337 6 8.50037 6H7.26136C8.69936 4.727 10.5603 4 12.5263 4C16.9223 4 20.5004 7.589 20.5004 12C20.5004 16.411 16.9233 20 12.5263 20C9.47125 20 6.74035 18.2991 5.39735 15.5601C5.15535 15.0641 4.55646 14.8581 4.05946 15.1021C3.56346 15.3451 3.35943 15.9439 3.60243 16.4399C5.28343 19.8699 8.70325 22 12.5263 22C18.0253 22 22.5004 17.514 22.5004 12C22.5004 6.486 18.0253 2 12.5263 2Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePast);
export default __webpack_public_path__ + "static/media/time-past.8ecc407fcc2aa62e333f3c43654887cc.svg";
export { ForwardRef as ReactComponent };